import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { inject } from '@angular/core';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { filter, first, map } from 'rxjs/operators';
import { InteractionStatus } from '@azure/msal-browser';
import { APP_ROUTES } from '@lp/routes';
import { Observable } from 'rxjs';

export function loggedOffGuard(): CanActivateFn {
  return (): Observable<boolean | UrlTree> => {
    const msal = inject(MsalService);
    const broadcast = inject(MsalBroadcastService);
    const router = inject(Router);

    return broadcast.inProgress$.pipe(
      filter((status) => status === InteractionStatus.None),
      first(),
      map(() => {
        const accounts = msal.instance.getAllAccounts();
        const isLoggedIn = accounts.length > 0;

        if (isLoggedIn) {
          return router.parseUrl(APP_ROUTES.chat);
        }
        return true;
      })
    );
  };
}
